export const cipFormSchema: any = {
  title: "",
  targetDate: "",
  cipCategoryId: [],
  cipTypeId: [],
  justification: "",
  entity: {},
  cost: 0,
  tangibleBenefits: [],
  attachments: [],
  year: "2023",
  locationId: "",
  actionItems: [],
  createdBy: "",
  reviewers: [],
  approvers: [],
  refsData: [],
  projectMembers:[],
  cancellation: "",
  organizationId: "",
  cipOrigin: [],
  plannedStartDate: "",
  plannedEndDate: "",
  actualStartDate: "",
  actualEndDate: "",
  cancellationReason:"",
  dropReason:"",
  otherMembers:"",
  buttonStatusInDates:false,
  cancellationButtonStatus:false,
};
